import React from 'react'
import Footer from '../../Footer/footer'

const Blog = () => {
  return (
    <div className='container-blog'>
      <div className='wrapper-beranda'>
        <div className='hero-beranda'>
                <h1>blog</h1>
              <div className='hero-img'>
              </div>
        </div>
      </div>
          <Footer />
    </div>
  )
}

export default Blog
